export default __webpack_public_path__ + "static/lgbtq-belmond-4-c98bfa96254b2b55814a43b409dc21c8.jpg";